import { AuthStorage } from "utils/auth-storage";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveReportAccessLevel } from "redux/permission-reducer";
import { WarehouseServices } from "apis/Services/WarehouseService";
import { Button, Input, Transfer } from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  SendOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import LoadingComponent from "components/loading-component";
import ProcoreLogo from "assets/images/Procore_Logo.svg";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import PurchasedOrdersTable from "./purchased-orders-table";
import GetPurchasedOrders from "./get-purchased-orders-modal";
import TransferToInventoryModal from "./transfer-to-inventory-modal";
import toast from "react-hot-toast";
import LineItemsModal from "./line-items-modal";

export default function WarehousePurchasedOrders() {
  const { company_id, id } = useParams();
  const [isLoading, setisLoading] = useState(true);
  const [isDataLoading, setisDataLoading] = useState(true);
  const [accessLevel, setAccessLevel] = useState();
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filterStatus, setFilterStatus] = useState("all"); // Add filter state
  const [isGetPurchasedOrdersVisible, setIsGetPurchasedOrdersVisible] =
    useState(false);

  // Filter buttons configuration
  const filterButtons = [
    { key: "all", label: "All" },
    { key: "open", label: "Open" },
    { key: "completed", label: "Completed" },
  ];
  const [isTransferModalVisible, setIsTransferModalVisible] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [locationsOptions, setLocationsOptions] = useState([]);
  const [unitsOptions, setUnitsOptions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [shouldReload, setShouldReload] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const tableRef = useRef();

  const { reportAccessLevel } = useSelector((state) => state.permission);
  const dispatch = useDispatch();

  function getAccessLevel() {
    setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    WarehouseServices.inventoryPageAccessLevel(ReqObj)
      .then((res) => {
        setAccessLevel(parseInt(res.accessLevel));
        if (parseInt(res?.accessLevel) > 0) {
          getData();
        } else {
          setisLoading(false);
        }
        dispatch(saveReportAccessLevel(res.accessLevel));
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getData() {
    setisDataLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getPurchaseOrdersInKoncurent(ReqObj)
      .then((res) => {
        setData(res);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setisLoading(false);
        setisDataLoading(false);
      });
  }

  useEffect(() => {
    if (shouldReload) {
      getData();
      setShouldReload(false);
    }
  }, [shouldReload]);

  useEffect(() => {
    getAccessLevel();
  }, []);

  const handleSelectionChange = (selectedRowKeys, selectedRowsData) => {
    setSelectedItems(selectedRowKeys);
    setSelectedRows(selectedRowsData);
  };

  const handleBulkTransfer = () => {
    setIsTransferModalVisible(true);
  };

  const handleTransferSubmit = (values) => {
    const toastId = toast.loading("Transferring to inventory...");

    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");

    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
      values: [...values?.items],
    };

    WarehouseServices.sendKoncurentPurchaseOrdersToInventory(ReqObj)
      .then((res) => {
        toast.success("Transferred successfully", { id: toastId });
        getData();
        clearSelection();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong, please try again.", {
          id: toastId,
        });
        clearSelection();
      })
      .finally(() => setisLoading(false));
  };

  const clearSelection = () => {
    setSelectedItems([]);
    setSelectedRows([]);
  };

  // Filter data based on status
  const getFilteredData = () => {
    if (!data?.purchaseOrders) return [];

    if (filterStatus === "completed") {
      return data.purchaseOrders.filter(
        (order) => order.inventoryStatus === "Sent",
      );
    }

    if (filterStatus === "open") {
      return data.purchaseOrders.filter(
        (order) => order.inventoryStatus !== "Sent",
      );
    }

    return data.purchaseOrders;
  };

  return (
    <div className=" bg-white p-4 rounded-3 p-2 d-flex flex-column justify-content-center">
      {isLoading && (
        <div className="row d-flex justify-content-center">
          <LoadingComponent />
        </div>
      )}

      {!isLoading && accessLevel === 0 && (
        <div className="row w-100 d-flex justify-content-center p-5">
          {!isLoading && accessLevel === 0 && (
            <div className="row w-100 d-flex justify-content-center p-5">
              <div className="d-flex flex-column align-items-center text-center gap-3">
                <LockRoundedIcon style={{ fontSize: "5rem", color: "#999" }} />
                <h6 className="mt-2 mb-0 text-muted">
                  You do not have the necessary permissions to access this page.
                </h6>
              </div>
            </div>
          )}
        </div>
      )}

      {!isLoading && accessLevel > 0 && (
        <div style={{ width: "85%" }} className=" align-self-center">
          <div className="row">
            <div>
              <h3 className="fw-bold p-0 m-0">Purchase Orders</h3>
              <p className="opacity-75 mt-2 p-0">
                {/* Track and manage all construction materials in your warehouse */}
              </p>
            </div>
          </div>

          <div className="row mt-2">
            {/* Filter Buttons and Action Buttons */}
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-3">
              {/* Filter Buttons */}
              <div className="d-flex gap-2 flex-wrap">
                {filterButtons.map((filter) => (
                  <Button
                    key={filter.key}
                    type={filterStatus === filter.key ? "primary" : "default"}
                    onClick={() => setFilterStatus(filter.key)}
                    shape="round"
                  >
                    {filter.label}
                  </Button>
                ))}
              </div>

              {/* Action Buttons */}
              <div className="d-flex flex-wrap gap-2">
                <Button
                  disabled={accessLevel < 2}
                  onClick={() => {
                    if (accessLevel > 1) {
                      setIsGetPurchasedOrdersVisible(true);
                    }
                  }}
                  size="large"
                >
                  <img src={ProcoreLogo} alt="Procore" width={16} />
                  Get Purchase Orders
                </Button>
              </div>
            </div>

            {/* Search Input */}
            <div className="mb-3">
              <input
                type="text"
                className="form-control rounded rounded-5"
                placeholder="Search title, number, material, status..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{
                  padding: "10px 20px",
                  border: "1px solid #d9d9d9",
                }}
              />
            </div>

            <PurchasedOrdersTable
              data={getFilteredData()}
              materialsData={data?.items}
              onDataUpdate={getData}
              searchText={searchText}
              loading={isDataLoading}
              showActions={true}
              onSelectionChange={handleSelectionChange}
              selectedItems={selectedItems}
              getData={getData}
              accessLevel={accessLevel}
            />
          </div>
        </div>
      )}

      <GetPurchasedOrders
        isGetPurchasedOrdersVisible={isGetPurchasedOrdersVisible}
        setIsGetPurchasedOrdersVisible={setIsGetPurchasedOrdersVisible}
        setShouldReload={setShouldReload}
        accessLevel={accessLevel}
      />

      <TransferToInventoryModal
        visible={isTransferModalVisible}
        onCancel={() => setIsTransferModalVisible(false)}
        onTransfer={handleTransferSubmit}
        itemsData={data?.items}
        selectedItems={selectedItems}
        selectedRows={selectedRows}
        accessLevel={accessLevel}
      />
    </div>
  );
}
